import { render, staticRenderFns } from "./SelectMenuItemsModal.vue?vue&type=template&id=05f1fc1e&"
import script from "./SelectMenuItemsModal.vue?vue&type=script&lang=js&"
export * from "./SelectMenuItemsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports